module.exports = __webpack_public_path__ + "img/heading-2.d6a074a7.jpg";